import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const get = async (path) => {
  const response = await axios.get(`${API}${path}`);
  return response.data;
};

const apiService = {
  getProfile: () => get("/profile"),
  getSkills: () => get("/skills"),
  getAchievements: () => get("/achievements"),
  getExperience: () => get("/experience"),
  getProjects: () => get("/projects"),
  getCertifications: () => get("/certifications"),
  getEducation: () => get("/education"),

  submitContactForm: async (formData) => {
    const response = await axios.post(`${API}/contact`, formData);
    return { success: true, message: "Message sent successfully!", data: response.data };
  },

  downloadResume: async () => {
    const response = await axios.get(`${API}/resume/download`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Saurav_Sinha_Resume.pdf");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  exchangeSession: async (sessionId) => {
    const response = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
    return response.data;
  },

  getMe: async () => {
    const response = await axios.get(`${API}/auth/me`, { withCredentials: true });
    return response.data;
  },

  authLogout: async () => {
    const response = await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    return response.data;
  },

  getInboxMessages: async () => {
    const response = await axios.get(`${API}/admin/contacts`, { withCredentials: true });
    return response.data;
  },

  deleteInboxMessage: async (id) => {
    const response = await axios.delete(`${API}/admin/contacts/${id}`, { withCredentials: true });
    return response.data;
  }
};

export default apiService;
